import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var Form = /*#__PURE__*/function (_Entity) {
  _inherits(Form, _Entity);

  var _super = _createSuper(Form);

  function Form() {
    _classCallCheck(this, Form);

    return _super.apply(this, arguments);
  }

  _createClass(Form, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "sections",
    get: function get() {
      return this.props.sections;
    }
  }, {
    key: "folderId",
    get: function get() {
      return this.props.folderId;
    }
  }, {
    key: "thumbnail",
    get: function get() {
      return this.props.thumbnail;
    }
  }, {
    key: "coverImage",
    get: function get() {
      return this.props.coverImage;
    }
  }, {
    key: "subjects",
    get: function get() {
      return this.props.subjects;
    }
  }, {
    key: "grades",
    get: function get() {
      return this.props.grades;
    }
  }, {
    key: "version",
    get: function get() {
      return this.props.version;
    }
  }, {
    key: "publishedVersion",
    get: function get() {
      var _this$props$published;

      return (_this$props$published = this.props.publishedVersion) !== null && _this$props$published !== void 0 ? _this$props$published : null;
    }
  }, {
    key: "tags",
    get: function get() {
      return this.props.tags;
    }
  }, {
    key: "category",
    get: function get() {
      return this.props.category;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "headings",
    get: function get() {
      return this.props.headings || [];
    }
  }, {
    key: "hasEssayOrFillInBlankQuestion",
    get: function get() {
      var _this$props$hasEssayO;

      return (_this$props$hasEssayO = this.props.hasEssayOrFillInBlankQuestion) !== null && _this$props$hasEssayO !== void 0 ? _this$props$hasEssayO : false;
    }
  }, {
    key: "totalQuestions",
    get: function get() {
      return this.props.totalQuestions;
    }
  }, {
    key: "totalScore",
    get: function get() {
      return this.props.totalScore;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
    /** Default assignment title when creating an assignment from this form. */

  }, {
    key: "addNewSection",
    value: function addNewSection(section) {
      this.props.sections.push(section);
    }
  }, {
    key: "updateSections",
    value: function updateSections(sections) {
      this.props.sections = sections;
    }
  }, {
    key: "deleteSection",
    value: function deleteSection(sectionId) {
      this.props.sections = this.props.sections.filter(function (s) {
        return s.id.toString() !== sectionId;
      });
    }
  }, {
    key: "updateHeadings",
    value: function updateHeadings(headings) {
      this.props.headings = headings;
    }
    /** Keep draft version in sync after question/form mutations (no full form reload). */

  }, {
    key: "updateVersion",
    value: function updateVersion(version) {
      this.props.version = version;
    }
  }, {
    key: "updatePublishedVersion",
    value: function updatePublishedVersion(publishedVersion) {
      this.props.publishedVersion = publishedVersion;
    }
  }], [{
    key: "getDefaultAssignmentTitle",
    value: function getDefaultAssignmentTitle(title) {
      var _title$trim;

      return (_title$trim = title === null || title === void 0 ? void 0 : title.trim()) !== null && _title$trim !== void 0 ? _title$trim : '';
    }
  }, {
    key: "create",
    value: function create(props) {
      var _props$publishedVersi;

      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.status,
        argumentName: 'Status'
      }, {
        argument: props.folderId,
        argumentName: 'Folder Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var form = new Form(_objectSpread(_objectSpread({}, props), {}, {
        publishedVersion: (_props$publishedVersi = props.publishedVersion) !== null && _props$publishedVersi !== void 0 ? _props$publishedVersi : null
      }), new UniqueEntityID(props.id));
      form.updatedAt = props.updatedAt;
      return Result.ok(form);
    }
  }]);

  return Form;
}(Entity);